import type { NskResponse } from "~/models/Api";
import { deleteRequest } from "~/utils/api/api_handler";

const paths = {
	logout: "logout"
};

export const logout = async (): Promise<NskResponse<{ url: string }>> =>
	deleteRequest(paths.logout);
